import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'app-file-delete-confirm',
  templateUrl: './file-delete-confirm.component.html',
  styleUrls: ['./file-delete-confirm.component.scss'],
})
export class FileDeleteConfirmComponent implements OnInit {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<FileDeleteConfirmComponent>,
    private fileService: FileService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { message: string,event : string }
  ) {}

  ngOnInit(): void {}

  dismiss() {
    this.bottomSheetRef.dismiss();
  }
  delete() {
    if(this.data?.event == "pendingInvoiceEvent"){
      this.fileService.pendingInvoiceEvent.next(true);
    }
    if(this.data?.event == "QRConvertToWOEvent"){
      this.fileService.QRConvertToWOEvent.next(true);
    }
    if(this.data?.event == "WOConvertToQREvent"){
      this.fileService.WOConvertToQREvent.next(true);
    }
    if(this.data?.event == "AcceptJobAsInProgressEvent"){
      this.fileService.AcceptJobAsInProgressEvent.next(true);
    }
    else{
      this.fileService.fileDeleteEvent.next(true);
    }

    this.dismiss();
  }

  getMessage(): string {
    if (this.data && this.data.message) {
      return this.data.message;
    } else {
      return 'Are you sure you want to delete this file?';
    }
  }
}
